import { useLocalStorage } from "./useLocalStorage";

export const useSavedStore = (): { storeId: number | null; setStoreId: (value: number | null) => void } => {
  const { storeId, setStoreId } = useLocalStorage();
  return { storeId: storeId || null, setStoreId };
};
